import React  from 'react';
import { useConnect } from '@lore/query-connect';
const CACHE_TTL = 60 * 1000; // 1 minute

export default function Partners(props) {
  const { offer } = props;

  const invited = useConnect('claim.find', {
      where: {
        eager: {
          $where: {
            offerId: offer.id,
            response: 'Pending'
          }
        }
      },
      pagination: {
        pageSize: 1,
        order: 'createdAt asc'
      },
      include: function (model) {
        return (
          model.data.offerId === offer.id &&
          model.data.response === 'Pending'
        )
      },
      exclude: function (model) {
        return (
          model.data.offerId !== offer.id ||
          model.data.response !== 'Pending'
        );
      }
    },
    {cacheTime: CACHE_TTL * 2, staleTime: CACHE_TTL, refetchOnWindowFocus: false}
  );

  const declined = useConnect('claim.find', {
      where: {
        eager: {
          $where: {
            offerId: offer.id,
            response: 'Decline'
          }
        }
      },
      pagination: {
        pageSize: 1,
        order: 'createdAt asc'
      },
      include: function (model) {
        return (
          model.data.offerId === offer.id &&
          model.data.response === 'Decline'
        );
      },
      exclude: function (model) {
        return (
          model.data.offerId !== offer.id ||
          model.data.response !== 'Decline'
        );
      }
    },
    {cacheTime: CACHE_TTL * 2, staleTime: CACHE_TTL, refetchOnWindowFocus: false});

  const connected = useConnect('claim.find', {
      where: {
        eager: {
          $where: {
            offerId: offer.id,
            response: 'Connect'
          }
        }
      },
      pagination: {
        pageSize: 1,
        order: 'createdAt asc'
      },
      include: function (model) {
        return (
          model.data.offerId === offer.id &&
          model.data.response === 'Connect'
        )
      },
      exclude: function (model) {
        return (
          model.data.offerId !== offer.id ||
          model.data.response !== 'Connect'
        );
      }
    },
    {cacheTime: CACHE_TTL * 2, staleTime: CACHE_TTL, refetchOnWindowFocus: false});

  return (
    <div className="whitespace-nowrap space-x-2">
      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
        {(declined && declined.meta && declined.meta.totalCount) || 0}
      </span>
      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
        {(invited && invited.meta && invited.meta.totalCount) || 0}
      </span>
      <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
        {(connected && connected.meta && connected.meta.totalCount) || 0}
      </span>
    </div>
  );
}
